import { combineReducers } from 'redux'
import * as redukers from 'reduker'
import * as actionTypes from './action-types'

export default combineReducers({
  request: redukers.request({
    start: actionTypes.FETCH_VENDORS,
    success: [actionTypes.SET_VENDORS, actionTypes.SET_PAGINATION],
    error: actionTypes.SET_FETCH_VENDORS_ERROR,
  }),
  list: redukers.entities({
    update: actionTypes.SET_VENDORS,
    mergeById: actionTypes.UPDATE_VENDOR,
  }),
  selectedIds: redukers.value(
    {
      set: actionTypes.SET_SELECTED,
      reset: actionTypes.RESET_SELECTED,
    },
    {},
  ),
  pagination: redukers.value(
    {
      set: actionTypes.SET_PAGINATION,
    },
    { page: 1, limit: 0, pages: 0, total: 0 },
  ),
  addVendorRequest: redukers.request({
    start: actionTypes.ADD_VENDOR,
    success: actionTypes.ADD_VENDOR_SUCCESS,
    error: [
      actionTypes.ADD_VENDOR_ERROR,
      actionTypes.ADD_VENDOR_NOT_REGISTERED,
    ],
    clear: actionTypes.ADD_VENDOR_CLEAR,
  }),
  addVendorConfirmed: redukers.value(
    {
      set: actionTypes.ADD_VENDOR_CONFIRM,
      reset: actionTypes.ADD_VENDOR_CLEAR,
    },
    false,
  ),
  getSearchOptions: redukers.request({
    start: actionTypes.GET_SEARCH_OPTIONS,
    clear: actionTypes.CLEAR_SEARCH_OPTIONS,
  }),
  searchOptions: redukers.value(
    {
      set: actionTypes.SET_SEARCH_OPTIONS,
      reset: actionTypes.CLEAR_SEARCH_OPTIONS,
    },
    [],
  ),
  searchFilters: redukers.value(
    {
      set: actionTypes.SET_SEARCH_FILTERS,
      reset: actionTypes.RESET_SEARCH_FILTERS,
    },
    { keyword: '' },
  ),
  removeRequest: redukers.request({
    start: actionTypes.REMOVE,
    error: actionTypes.REMOVE_ERROR,
    success: actionTypes.REMOVE_SUCCESS,
  }),
})
